export default "__VITE_ASSET__po4vci8o__"